import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import { FC, useEffect, useRef, useState } from 'react'
import { Form as FinalForm } from 'react-final-form'
import SearchResearcher from '../../component/um/researcher/SearchResearcher'
import SearchResearcherResult from '../../component/um/researcher/SearchResearcherResult'
import useResearcherHook from '../../component/web/shareLogic/useResearcherHook'
import SearchAccordion from '../../control/accordion/SearchAccordion'
import useLoading from '../../control/loading/useLoading'
import useTranslate from '../../i18n/useTranslate'
import { SearchResearcherResponse } from '../../services/um/types/researcherType'

const ManageResearcher: FC<{}> = () => {
    const initialFormValues = {
        keyword: '',
        researcherType: null,
    }
    const [searchResult, setSearchResult] = useState<SearchResearcherResponse>()
    const translate = useTranslate()
    const loadingHook = useLoading()
    const researcherHook = useResearcherHook()
    const currentPageNoRef = useRef<number>(1)
    const formRef = useRef<Record<string, any>>()
    const elRef = useRef<any>(null)

    const submitSearch = async (values: Record<string, any>, resetPage: boolean, lazy = false) => {
        if (resetPage) {
            currentPageNoRef.current = 1
        }
        loadingHook.loadingOpen()
        const response = await handleSearch(values)
        loadingHook.loadingClose()
        if (lazy) {
            setTimeout(() => {
                setSearchResult(response ?? [])
            }, 400)
        } else {
            setSearchResult(response ?? [])
        }
    }

    const handleSearch = (values: Record<string, any>) => {
        return researcherHook.searchResearcher(values.keyword, currentPageNoRef.current * 10)
    }

    const handleScroll = async () => {
        if (elRef.current && isBottom(elRef.current)) {
            window.removeEventListener('scroll', handleScroll)
            await handleScrollEnd()
            setTimeout(() => {
                window.addEventListener('scroll', handleScroll, { passive: true })
            }, 1000)
        }
    }

    const isBottom = (el: any) => {
        return el.getBoundingClientRect().bottom - window.innerHeight * 0.01 <= window.innerHeight
    }

    const handleScrollEnd = () => {
        currentPageNoRef.current = currentPageNoRef.current + 1
        return submitSearch(formRef?.current?.getState()?.values, false, true)
    }

    useEffect(() => {
        submitSearch(
            {
                keyword: null,
            },
            true,
        )
        window.addEventListener('scroll', handleScroll, { passive: true })
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    return (
        <Container maxWidth="lg" ref={elRef}>
            <FinalForm onSubmit={(val) => submitSearch(val, true)} initialValues={initialFormValues}>
                {({ form }) => {
                    formRef.current = form
                    return (
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <SearchAccordion title={translate.get('UM.RESEARCHER.TITLE')}>
                                    <SearchResearcher />
                                </SearchAccordion>
                            </Grid>
                            <Grid item xs={12}>
                                <SearchResearcherResult searchResult={searchResult} submitSearch={submitSearch} />
                            </Grid>
                        </Grid>
                    )
                }}
            </FinalForm>
        </Container>
    )
}

export default ManageResearcher
